var defaultSetup = function() {
  return {
    crafting: [
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "item.minecraft.iron_ingot",
          "item.minecraft.iron_axe",
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
        ]
      },
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "item.minecraft.bucket",
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
        ]        
      },
      {
        enabled: true,
        size: 2,
        weight: 1.0,
        goals: [
          "item.minecraft.flint_and_steel"
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.flint",
          "item.minecraft.bucket"
        ]       
      },
      {
        enabled: true,
        size: 2,
        weight: 1.0,
        goals: [
          "block.minecraft.nether_bricks"
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks",
          "item.minecraft.nether_brick"
        ]
      },
      {
        enabled: true,
        size: 2,
        weight: 1.0,
        goals: [
          "block.minecraft.white_wool",
          "block.minecraft.glowstone"
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks",
          "item.minecraft.nether_brick"
        ]
      },
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "item.minecraft.golden_carrot",
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks"
        ]
      },
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_ingot",
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.diamond",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks"
        ]
      },
      {
        enabled: true,
        size: 2,
        weight: 1.0,
        goals: [
          "item.minecraft.ender_eye",
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_log",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks",
          "item.minecraft.blaze_powder",
          "item.minecraft.blaze_rod",
        ]
      },
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "item.minecraft.bow"
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks",
          "item.minecraft.blaze_powder",
          "item.minecraft.blaze_rod",
        ]
      },
      {
        enabled: true,
        size: 3,
        weight: 1.0,
        goals: [
          "block.minecraft.white_bed",
          "block.minecraft.respawn_anchor"
        ],
        inventory: [
          "block.minecraft.dirt",
          "block.minecraft.oak_planks",
          "item.minecraft.stick",
          "item.minecraft.iron_nugget",
          "item.minecraft.iron_ingot",
          "item.minecraft.gold_nugget",
          "item.minecraft.gold_ingot",
          "item.minecraft.wheat",
          "item.minecraft.carrot",
          "item.minecraft.bucket",
          "block.minecraft.obsidian",
          "block.minecraft.crying_obsidian",
          "item.minecraft.ender_pearl",
          "item.minecraft.glowstone_dust",
          "block.minecraft.glowstone",
          "item.minecraft.string",
          "block.minecraft.white_wool",
          "block.minecraft.gravel",
          "block.minecraft.soul_sand",
          "block.minecraft.nether_bricks",
          "block.minecraft.blackstone",
          "block.minecraft.polished_blackstone_bricks",
          "item.minecraft.blaze_powder",
          "item.minecraft.blaze_rod",
        ]
      }
    ],
    options: {
      max_characters: 3,
      score_search_lengths: true,
      optimize_unique_characters: true,
      search: '',
      auto_search: true,
      letter_penalty: 5.0,
      junk_penalty: 10.0,
      has_junk_penalty: 100.0,
      fail_penalty: 1000,
      allow_permitted_items: false,
      permit_goal_items: false,
      permitted_items_benefit: 10,
      permitted_items: [
        "item.minecraft.bow",
        "item.minecraft.crossbow",
        "item.minecraft.shield",
        "item.minecraft.oak_boat",
        "item.minecraft.bread",
        "item.minecraft.golden_boots",
        "item.minecraft.golden_helmet",
        "item.minecraft.cauldron"
      ],
      overlap_crafting: true,
      overlap_penalty: 20,
      resource_id: true
    }
  }
}

export const DefaultSetup = defaultSetup;
